import React, { Component } from 'react'
import { connect } from 'react-redux'
import { adminLoadActions, adminDelActionsItem } from '../actions/adminActions'
import AdminActionsComponent from '../components/AdminActions'
import { withRouter } from 'react-router-dom'

class AdminActions extends Component {

    componentDidMount() {
        this.props.loadAll()
    }

    render() {
        return (
            <AdminActionsComponent {...this.props} />
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.adminActions)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        loadAll: () => {
            dispatch(adminLoadActions())
        },
        remove: (item) => {
            dispatch(adminDelActionsItem(item))
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminActions))



// WEBPACK FOOTER //
// ./src/containers/AdminActions.js